import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

export const UserFilterModel = new Record({
    first_name: "",
    last_name: "",
    name: "",
    status: "",
    including_communities: ""
})

const tagFields = ["including_communities"]

export const updateUserSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields
    )
